import React from 'react';
import { Col } from 'react-bootstrap';

import BlockWrapper from '../../../components/blocks/BlockWrapper';
import GenericBlock from '../../../components/blocks/GenericBlock';
import IconBlock from '../../../components/blocks/IconBlock';
import YoutubeVideoImage from "../../../components/YoutubeVideoImage";

export default class Strategy extends React.Component {

    constructor(props) {
        super(props);

        this.title = 'Strategy';
    }

    render() {
        return (
            <BlockWrapper id="strategy">
                <IconBlock className="hidden-xs hidden-sm" icon="screenshot">
                    <h3>{this.title}</h3>
                </IconBlock>

                <GenericBlock>
                    <div className="col-md-6 col-sm-12 col-xs-12">
                        <h4>{this.title}</h4>
                        <p>
                            There’s an unquestionable pattern of accelerating change today that almost every global university has to deal with. Consequently, learning is not only about ‘knowing’ but also about ‘doing’. TROI delivers you a high return on education.
                        </p>

                        <h4>What clients say</h4>
                        <p>
                            <i>"TROI understands how Strategy and Learning Design are linked. Their consultants are senior and strive for business results. TROI delivers leadership support and goes beyond a pure media play."</i>
                        </p>
                        <p className="text-right"><i>Dean</i></p>
                    </div>

                    <Col md={6} sm={12} xs={12}>
                        <h4>Check out the video</h4>
                        <YoutubeVideoImage videoId="Q40BbxXJXNE" />
                        <div className="clearfix"></div>
                    </Col>
                </GenericBlock>
            </BlockWrapper>
        );
    }

}



// WEBPACK FOOTER //
// ./src/pages/parts/universities/Strategy.js